import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Checkbox, FormGroup, FormControl, RadioGroup, FormControlLabel, TextField, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardAbsentReason } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import ConfModal from "../../Modal/ConfModal";
import { getGridStringOperators } from "@mui/x-data-grid";
import MyTable from "../../Schedule/MyTable";
import { toast } from 'react-toastify';

export default function UpdateDBStructure() {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState([]);

    const {
        register,
        control,
        formState: { errors, isValid },
        handleSubmit,
        setError,
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {

        },
    });
    let columns = [
        {
            field: 'name', headerName: 'Name', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'value', headerName: 'Value', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
    ];
    const onSubmit = (body) => {
        console.log('body', body);
        setLoading(true);
        ApiService.post('/postExecSQL', body).then((data) => {
            setLoading(false);
            console.log('data', data);
            setModalData(data.data)
            setOpen(true);
            if (data.message) {
                toast.success(data.message)
                // enqueueSnackbar(data.message, { variant: "success" });
            } else {
                toast.success('Success')
                // enqueueSnackbar('success', { variant: 'success' });
            }
        }).catch(({ data }) => {
            setLoading(false);
            toast.error('Error')
            // enqueueSnackbar('Error', { variant: 'error' });
        });
    }
    let closeModal = () => {
        setOpen(false);
    }
    return <>
        <Typography fontWeight='700' fontSize="16px"> Update DB Structure</Typography>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-12">
                <FormControl sx={{ gap: "12px" }}>
                    <RadioGroup
                        defaultValue={"Validate"}
                        name="radio-buttons-group"
                        row
                    >

                        <FormControlLabel
                            value="TEST"
                            {...register("type", { required: "Type Name is required" })}
                            control={<Radio />}
                            label={
                                <Typography sx={{ fontSize: '14px' }}
                                >
                                    Test
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value="DEMO"
                            {...register("type", { required: "Type Name is required" })}
                            control={<Radio />}
                            label={
                                <Typography sx={{ fontSize: '14px' }}
                                >
                                    Demo
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value="LIVE"
                            {...register("type", { required: "Type Name is required" })}
                            control={<Radio />}
                            label={
                                <Typography sx={{ fontSize: '14px' }}
                                >
                                    Live
                                </Typography>
                            }
                        />
                    </RadioGroup>
                </FormControl>
                {errors.type && <Error>{errors.type?.message}</Error>}
            </div>
            <div className="col-12 my-2">
                <ButtonTheme disabled={!isValid || loading} color='primary' type='submit'>Exec SQL</ButtonTheme>
            </div>


        </form>
        <ConfModal Title='DataBase' open={open} closeModal={closeModal} >
            {modalData && modalData && modalData.length > 0 &&
                <div >
                    <MyTable
                        rows={modalData}
                        columns={columns}
                        useTopFilter={false}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                </div>
            }

        </ConfModal>
    </>
}
